import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { faCaretDown, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { Button, OverlayTrigger } from 'ui';
import { Input } from 'ui/fields';
import { BookerContext } from '../Booker.js';
import classNames from 'classnames';
const Form = ({ value, onChange, id }) => {
    const intl = useIntl();
    const [innerValue, setInnerValue] = useState(value || '');
    const { useTailwindPrefix } = useContext(BookerContext);
    useEffect(() => {
        value !== null && value !== undefined && setInnerValue(value);
    }, [value]);
    function onChangeValue(event) {
        setInnerValue(event.target.value);
    }
    function onSubmit() {
        onChange(innerValue);
    }
    return (_jsxs(_Fragment, { children: [_jsx(Input, { id: id, label: intl.formatMessage({ id: 'booker.promotion.code' }), name: `${id}.promotionCode`, type: "text", value: innerValue, onChange: onChangeValue, useTailwindPrefix: useTailwindPrefix, className: classNames({
                    'mb-4 md:mb-0 text-[100%]': !useTailwindPrefix,
                    'tw-mb-4 md:tw-mb-0 tw-text-[100%]': useTailwindPrefix,
                }) }), _jsx(Button, Object.assign({ bsStyle: "outline-primary", className: classNames({
                    'block w-1/2 md:w-full md:my-6': !useTailwindPrefix,
                    'tw-block tw-w-1/2 md:tw-w-full md:tw-my-6': useTailwindPrefix,
                }), onClick: onSubmit }, { children: intl.formatMessage({ id: 'booker.promotion.code.apply' }) }))] }));
};
export function PromoCodeSelector({ id = 'pCode' }) {
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState(false);
    const { control, setValue } = useFormContext();
    const { useTailwindPrefix, vertical, version } = useContext(BookerContext);
    const promotionCode = useWatch({ control, name: 'promotionCode' });
    function close() {
        setIsOpen(false);
    }
    function reset() {
        setValue('promotionCode', '');
        setValue('loyaltyPlan.promotionCode', undefined);
    }
    function getPromotionCodeText() {
        if (!promotionCode || promotionCode === '') {
            return (_jsxs(_Fragment, { children: [intl.formatMessage({ id: 'booker.promotion.question' }), " ", _jsx(FontAwesomeIcon, { icon: faCaretDown })] }));
        }
        else {
            return (_jsxs("div", Object.assign({ className: classNames({
                    'flex space-x-2': !useTailwindPrefix,
                    'tw-flex tw-space-x-2': useTailwindPrefix,
                }) }, { children: [_jsxs("span", { children: [intl.formatMessage({ id: 'booker.promotion.code' }), ":"] }), _jsxs("strong", { children: [promotionCode, " ", _jsx(FontAwesomeIcon, { icon: faCaretDown })] }), _jsxs("span", Object.assign({ onClick: reset }, { children: [_jsx(FontAwesomeIcon, { icon: faTrash }), " ", intl.formatMessage({ id: 'booker.promotion.code.delete' })] }))] })));
        }
    }
    return (_jsx("div", Object.assign({ className: classNames({ 'relative ': !useTailwindPrefix, 'tw-relative': useTailwindPrefix }) }, { children: _jsxs(OverlayTrigger, Object.assign({ isOpen: isOpen, onToggle: setIsOpen }, { children: [_jsx(OverlayTrigger.Trigger, Object.assign({ className: classNames({
                        'text-[85%] mb-3 md:mb-0': !useTailwindPrefix,
                        'tw-text-[85%] tw-mb-3 md:tw-mb-0': useTailwindPrefix,
                    }), componentTag: "div" }, { children: _jsx("span", Object.assign({ className: classNames('itm-booker-promoCode', {
                            'cursor-pointer text-link-blue': !useTailwindPrefix,
                            'tw-cursor-pointer tw-text-link-blue': useTailwindPrefix,
                        }) }, { children: getPromotionCodeText() })) })), _jsxs(OverlayTrigger.Overlay, Object.assign({ className: classNames({
                        'md:rounded-widget-pill-overlays-border-radius': !useTailwindPrefix && !vertical && version === 'padded',
                        'md:tw-rounded-widget-pill-overlays-border-radius': useTailwindPrefix && !vertical && version === 'padded',
                        'bg-gray-100 md:z-10 md:bg-white md:shadow md:border border-gray-200 md:absolute min-w-[250px] right-0 p-6 box-content my-2': !useTailwindPrefix,
                        'tw-bg-gray-100 md:tw-z-10 md:tw-bg-white md:tw-shadow md:tw-border tw-border-gray-200 md:tw-absolute tw-min-w-[250px] tw-right-0 tw-p-6 tw-box-content tw-my-2': useTailwindPrefix,
                    }) }, { children: [_jsx(Controller, { control: control, name: "promotionCode", render: ({ field: { value, onChange } }) => (_jsx(Form, { id: id, value: value, onChange: (value) => {
                                    onChange(value);
                                    close();
                                } })) }), _jsx("span", Object.assign({ className: classNames({
                                'hidden md:block text-center cursor-pointer text-link-blue': !useTailwindPrefix,
                                'tw-hidden md:tw-block tw-text-center tw-cursor-pointer tw-text-link-blue': useTailwindPrefix,
                            }), onClick: close }, { children: intl.formatMessage({ id: 'booker.promotion.code.cancel' }) }))] }))] })) })));
}
